import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-add-phone',
  templateUrl: './add-phone.component.html',
  styleUrls: ['./add-phone.component.scss'],
})
export class AddPhoneComponent {
  @Input()
  public showRemoveButton = true;
  @Output()
  public wasAddedEmitter = new EventEmitter<boolean>();

  private _wasAdded = false;

  public get wasAdded(): boolean {
    return this._wasAdded;
  }

  public add(): void {
    this._wasAdded = true;
    this.emitEvent();
  }

  public remove(): void {
    this._wasAdded = false;
    this.emitEvent();
  }

  private emitEvent(): void {
    this.wasAddedEmitter.emit(this.wasAdded);
  }
}
